var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 73,
    viewBox: "0 0 69 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4578 73L6.27942 65.7027L0 0H69L62.7139 65.6924L34.4578 73ZM34.5 29.7403H45.8561L46.6421 21.4887H34.5H13.625L12.8398 13.4304H34.5H56.1087L54.5492 29.7403L54.3384 31.9042L52.3086 53.1187L52.1787 54.4801L34.5 59.0508L34.4602 59.0624L16.7658 54.4801L15.5556 41.8276H24.2269L24.8419 48.2544L34.4621 50.6777L34.4701 50.6757L44.1043 48.2492L45.107 37.7984H34.5H15.1696L14.3954 29.7403H34.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.bf0a81ef3a94b05c1045f9e29cba9593.svg";
export { ForwardRef as ReactComponent };